import { render, staticRenderFns } from "./SubjectInfo.vue?vue&type=template&id=2c7dd73e&scoped=true&"
import script from "./SubjectInfo.vue?vue&type=script&lang=js&"
export * from "./SubjectInfo.vue?vue&type=script&lang=js&"
import style0 from "./SubjectInfo.vue?vue&type=style&index=0&id=2c7dd73e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7dd73e",
  null
  
)

export default component.exports